import React, { Component } from 'react';

class HeroText extends Component {
  render() {
    const { data } = this.props;
    const backgroundImage = data.image?.childImageSharp?.fluid?.src || data.image;

    return (
      <div
        className="full-width-image"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          height: '450px',
          marginTop: '6rem',
        }}
      >
        <div className="herotext-content-wrapper">
          {data.title &&
						<h1 className="herotext-title">{data.title}</h1>
					}
          {data.secondtitle &&
						<h1 className="herotext-subtitle">{data.secondtitle}</h1>
					}
          {data.description &&
						<h1 className="herotext-description">{data.description}</h1>
					}
        </div>
      </div>
    );
  }
}

export default HeroText;
